module.exports = __webpack_public_path__ + "static/media/2.09e3e2d7.jpg";